import * as Sentry from '@sentry/browser'
import DizzyRobot from 'images/dizzy-robot.svg'
import React from 'react'
import { connect } from 'react-redux'

import { Button } from '@driftt/dds'
import {
  Div,
  H3,
  P 
} from '@driftt/tide-core'

const mapStateToProps = state => ({
  userEmail: state.user.email,
  userName: state.user.name 
})

const ErrorFallback = ({
  userEmail,
  userName 
}) => (
  <Div className="error-empty-state--wrapper">
    <img src={DizzyRobot} alt="dizzy robot error illustration" />
    <H3>Sorry, something went wrong.</H3>
    <P>You can help improve Drift by providing more information about what happened!</P>
    <Button 
      onClick={() => Sentry.showReportDialog({
        user: {
          email: userEmail,
          name: userName
        }
      })} 
    >
      Submit your feedback
    </Button>
  </Div>
)

export default connect(mapStateToProps)(ErrorFallback)
